// extracted by mini-css-extract-plugin
export default {"bankstatementBox":"bankStatement_bankstatementBox__aBsxH"};